<template>
  <div class="gdtgb">
    <!-- 提示框 -->
<transition name="van-fade">
  <div class="dzcg" v-if="tsk==1"><span>{{tsnr}}</span></div>
</transition>
<transition name="van-fade">
  <div class="dzcgs" v-if="tsks==1"><span>{{tsnr}}</span></div>
</transition>
<audio src="../assets/dh/1.mp3" id="yinyue"
          
        autoplay          
        loop         
        preload 
        @playing="ztsj()" 
        @pause="ztbf()"   
></audio>
    <!-- 加载页面 -->
    <transition name="van-fade">
      <div class="bg1" v-if="ymsx == 1">
        <div class="bgz">
          <img src="../assets/loa/logo.png" alt="" class="logo" />
          <div class="yuyq" @click="yinyue">
            <img src="../assets/loa/yyfh.png" alt="" class="yyfh" @click="yinyue" id="yyfh"/>
          </div>
          <img src="../assets/loa/zbt.png" alt="" class="zbt" />
          <img src="../assets/dh/1.gif" alt="" class="xr" />
          <div class="bfb">{{ loajs }}%</div>
          <div class="srk">
            <div class="nck">
              <img src="../assets/loa/jzt.png" alt="" class="jzt" id="jztdh"/>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <!-- 首页页面 -->
    <transition name="van-fade">
      <div v-if="ymsx == 2" class="bg2">
        <div class="bgz">
          <img src="../assets/loa/logo.png" alt="" class="logo" />
          <img src="../assets/loa/zbt.png" alt="" class="zbt" />
          <img src="../assets/dh/3.gif" alt="" class="xr" />
          <img src="../assets/loa/wzys.png" alt="" class="wzys" />
          <div class="srk">
            <img
              src="../assets/loa/yhks.png"
              alt=""
              class="yhks"
              v-if="ydyc == 1"
            />
            <div class="ncsrk" id="hdys">
              <div class="yqq"                  
               @touchmove="szyd"
                  @touchstart="szax"
                  @touchend="szlk">
                <img
                  src="../assets/loa/hdks.png"
                  alt=""
                  class="hdks"
                  @touchmove="szyd"
                  @touchstart="szax"
                  @touchend="szlk"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <!-- 输入姓名页面 -->
    <transition name="van-fade">
      <div v-if="ymsx == 3" class="bg3">
        <div class="bgz">
          <img src="../assets/loa/logo.png" alt="" class="logo" />
          <img src="../assets/loa/zbt.png" alt="" class="zbt" />
          <img src="../assets/dh/2.gif" alt="" class="xr" />
          <img src="../assets/loa/qsr.png" alt="" class="qsr" />
          <input type="text" placeholder="你的名字" class="srk" v-model="nam" />
          <img src="../assets/loa/qrmz.png" alt="" class="qrmz" @click="qrmz" />
        </div>
      </div>
    </transition>
    <!-- 年度关键词页面 -->
    <transition name="van-fade">
      <div class="bg4" v-if="ymsx == 4">
        <div class="mengcen" v-if="mcloa == 1"></div>
        <div class="scjz" v-if="mcloa == 1">
          <div class="bfb">{{ mcs }}%</div>
          <div class="srk">
            <div class="nck">
              <img src="../assets/loa/jzt.png" alt="" class="jzt" />
            </div>
          </div>
          <div class="nzgjc">正在生成你的年终关键词</div>
        </div>
        <div class="dingbu" id="jc">
        <img src="../assets/loa/fh.png" alt="" class="fhsy" @click="fh3" />
                <div class="wzz">
          你有<span class="sz">{{ bcxzx.length }}</span
          >个年度关键词
        </div>
        </div>
        <img src="../assets/loa/djsc.png" alt="" class="qrsc" @click="sctp" />

                  <!-- @touchstart="szax" -->
        <!-- <img src="" alt=""> -->
        <div class="bgz" >
          <div class="ds1" id="ul1">
            <div v-for="(val, i) in itb3" :key="i" class="oli" :id="`ds${i}`">
              <div :id="`xz${i}`" style="display: none">
                <img src="../assets/loa/yz.png" alt="" class="fgh" />
                <img src="../assets/loa/xzs.png" alt="" class="xzdh" />
              </div>
              <img
                :src="val.img"
                alt=""
                class="tbimg"
                @click="tjjgh(i, val.img)"
              />
            </div>
          </div>
        </div>
      </div>
    </transition>
    <!-- 生成加载页 -->
      
        <div class="bg5" v-if="ymsx == 5">
        <img :src="scdtp" alt="" class="scdtp" >
        <img :src="scdtp" alt="" class="scdtps" >
        <img :src="scdtp" alt="" class="scdtpss" >
        <img src="../assets/loa/bgt.png" alt="" class="bgt" />
        <div class="bgz">
          <img src="../assets/loa/logo.png" alt="" class="logo" />
          <div class="txk">
            <img :src="txx" alt="" class="toux" />
          </div>
          <div class="namm">{{nam}}</div>
          <img src="../assets/loa/jgys.png" alt="" class="bttp" />
          <div class="ftbg"></div>
          <img src="../assets/loa/fgx.png" alt="" class="ftiao" />
          <div class="xzdk">
            <div class="tpk" v-for="(a, i) in bcxzx" :key="i">
              <img :src="a" alt="" />
            </div>
          </div>
        </div>
        <img src="../assets/loa/bgd.png" alt="" class="bgd" />
        <div class="buzz">
          <img src="../assets/loa/ckgjc.png" alt="" class="dibu"  @click='zzzb'/>
          <img src="../assets/loa/ckgjcw.png" alt="" class="dibu2" />
          <img src="../assets/loa/ckgjcr.png" alt="" class="dibu3" />
        </div>
      </div>
      <!-- <img :src="wang" alt=""> -->
      <div class="bg6" v-if="ymsx == 5" id="wang">
        <img src="../assets/loa/bgt.png" alt="" class="bgt" />

        <div class="gtk">
          
 
          <img src="../assets/loa/logo.png" alt="" class="logo" />
          <div class="txk">
            <img :src="txx" alt="" class="toux" />
          </div>
          <div class="namm">{{nam}}</div>
          <img src="../assets/loa/jgys.png" alt="" class="bttp" />

        </div>      
          <div class="ftbg"><img src="../assets/loa/fgx.png" alt="" class="ftiao" /></div>
          
          <div class="xzdk">
            <div class="tpk" v-for="(a, i) in bcxzx" :key="i">
              <img :src="a" alt="" />
            </div>
          </div>
          <div class="wldd">
          <img src="../assets/loa/bgd.png" alt="" class="bgd" />
            <img src="../assets/loa/sctptbw.png" alt="" class="wan1">
            <img src="../assets/loa/sctper.png" alt="" class="wan2">
          </div> 
        <!-- </div> -->
        <!-- <img src="../assets/loa/bgd.png" alt="" class="bgd" /> -->
        <!-- <div class="buzz">
          <img src="../assets/loa/ckgjc.png" alt="" class="dibu" />
          <img src="../assets/loa/ckgjcw.png" alt="" class="dibu2" />
          <img src="../assets/loa/ckgjcr.png" alt="" class="dibu3" />
        </div> -->
      </div>
  </div>
</template>
<script>
import html2canvas from "html2canvas";

export default {
  data() {
    return {
      txx:require('../assets/loa/t1.png'),
      txq:[
        require('../assets/loa/t1.png'),
        require('../assets/loa/t2.png'),
        require('../assets/loa/t3.png'),
      ],
      tsks:0,
      tsnr:"",//kong
      tsk:0,
      yy:1,
      tp:null,
      scdtp: "",
      mcs: 0,
      mcloa: 0,
      nam: "",
      loajs: 0, //加载的进度条定时器
      ymsx: 1, //页面顺序
      ydyc: 1, //手指移动的时候隐藏提示文字
      hdjs: 0, //首页手指移动的位置
      anxd: 0, //首页手指按下准备移动时候的位置
      dddwz: 0, //手指到达的位置
      itb1: [
        { img: require("../assets/tb/1.png") },
        { img: require("../assets/tb/2.png") },
        { img: require("../assets/tb/3.png") },
        { img: require("../assets/tb/4.png") },
        { img: require("../assets/tb/5.png") },
        { img: require("../assets/tb/6.png") },
        { img: require("../assets/tb/7.png") },
        { img: require("../assets/tb/8.png") },
        { img: require("../assets/tb/9.png") },
        { img: require("../assets/tb/10.png") },
        { img: require("../assets/tb/11.png") },
        { img: require("../assets/tb/12.png") },
        { img: require("../assets/tb/13.png") },
        { img: require("../assets/tb/14.png") },
        { img: require("../assets/tb/15.png") },
        { img: require("../assets/tb/16.png") },
        { img: require("../assets/tb/17.png") },
        { img: require("../assets/tb/18.png") },
        { img: require("../assets/tb/19.png") },
        { img: require("../assets/tb/20.png") },
        { img: require("../assets/tb/21.png") },
        { img: require("../assets/tb/22.png") },
        { img: require("../assets/tb/23.png") },
        { img: require("../assets/tb/24.png") },
        { img: require("../assets/tb/25.png") },
        { img: require("../assets/tb/26.png") },
        { img: require("../assets/tb/27.png") },
        { img: require("../assets/tb/28.png") },
        { img: require("../assets/tb/29.png") },
        { img: require("../assets/tb/30.png") },
        { img: require("../assets/tb/31.png") },
        { img: require("../assets/tb/32.png") },
        { img: require("../assets/tb/33.png") },
        { img: require("../assets/tb/34.png") },
        { img: require("../assets/tb/35.png") },
        { img: require("../assets/tb/36.png") },
        { img: require("../assets/tb/37.png") },
        { img: require("../assets/tb/38.png") },
        { img: require("../assets/tb/39.png") },
        { img: require("../assets/tb/40.png") },
        { img: require("../assets/tb/41.png") },
        { img: require("../assets/tb/42.png") },
        { img: require("../assets/tb/43.png") },
        { img: require("../assets/tb/44.png") },
        { img: require("../assets/tb/45.png") },
        { img: require("../assets/tb/46.png") },
        { img: require("../assets/tb/47.png") },
        { img: require("../assets/tb/48.png") },
        { img: require("../assets/tb/49.png") },
        { img: require("../assets/tb/50.png") },
      ],
       yjzsytp: [
        { img: require("../assets/tb/1.png") },
        { img: require("../assets/tb/2.png") },
        { img: require("../assets/tb/3.png") },
        { img: require("../assets/tb/4.png") },
        { img: require("../assets/tb/5.png") },
        { img: require("../assets/tb/6.png") },
        { img: require("../assets/tb/7.png") },
        { img: require("../assets/tb/8.png") },
        { img: require("../assets/tb/9.png") },
        { img: require("../assets/tb/10.png") },
        { img: require("../assets/tb/11.png") },
        { img: require("../assets/tb/12.png") },
        { img: require("../assets/tb/13.png") },
        { img: require("../assets/tb/14.png") },
        { img: require("../assets/tb/15.png") },
        { img: require("../assets/tb/16.png") },
        { img: require("../assets/tb/17.png") },
        { img: require("../assets/tb/18.png") },
        { img: require("../assets/tb/19.png") },
        { img: require("../assets/tb/20.png") },
        { img: require("../assets/tb/21.png") },
        { img: require("../assets/tb/22.png") },
        { img: require("../assets/tb/23.png") },
        { img: require("../assets/tb/24.png") },
        { img: require("../assets/tb/25.png") },
        { img: require("../assets/tb/26.png") },
        { img: require("../assets/tb/27.png") },
        { img: require("../assets/tb/28.png") },
        { img: require("../assets/tb/29.png") },
        { img: require("../assets/tb/30.png") },
        { img: require("../assets/tb/31.png") },
        { img: require("../assets/tb/32.png") },
        { img: require("../assets/tb/33.png") },
        { img: require("../assets/tb/34.png") },
        { img: require("../assets/tb/35.png") },
        { img: require("../assets/tb/36.png") },
        { img: require("../assets/tb/37.png") },
        { img: require("../assets/tb/38.png") },
        { img: require("../assets/tb/39.png") },
        { img: require("../assets/tb/40.png") },
        { img: require("../assets/tb/41.png") },
        { img: require("../assets/tb/42.png") },
        { img: require("../assets/tb/43.png") },
        { img: require("../assets/tb/44.png") },
        { img: require("../assets/tb/45.png") },
        { img: require("../assets/tb/46.png") },
        { img: require("../assets/tb/47.png") },
        { img: require("../assets/tb/48.png") },
        { img: require("../assets/tb/49.png") },
        { img: require("../assets/tb/50.png") },
        { img: require("../assets/dh/1.gif") },
        { img: require("../assets/dh/1.gif") },
        { img: require("../assets/dh/1.gif") },
        { img: require("../assets/loa/bg.png")},
      ],
      itb3: [],
      lis: 0,
      bcxzx: [],
    };
  },
  mounted() {
    this.tjz()
    this.dsqs();
          // this.$axios.get("http://api.xiaoxxx.com/sensitive", `callback='backfn'&word='123456'`)
          // .then((res) => {
          //  console.log(res)
          // });
      // this.pbl()
      
      // console.log(yin.pause)
      // this.waaa()
  },
  watch: {
    ymsx:function(){
      if(this.ymsx==4){
                setTimeout(() => {
          
        
            var url = window.location.href; //获取url
    if (url.indexOf("uc_biz_str") >= 0) {
      //判断url地址中是否包含code字符串
      console.log("you");
      var jc=document.getElementById("jc")
      // console.log(jc)
      jc.style.height="1.6rem"
    } else {
            var jc=document.getElementById("jc")
      // console.log(jc)
      jc.style.height="1.3rem"
    }
    }, 10);
      }
      
    },
    tp:function(){
      console.log(this.tp)
      if(this.tp==this.yjzsytp.length){

       var jztdh=document.getElementById("jztdh")
        jztdh.style.animationPlayState="running"
        this.jishi = setInterval(() => {
        this.loajs++;
      }, 50);
      }
    },
    // 监听加载条
    loajs: function () {
      if(this.loajs==80){
        if(this.tp!=this.yjzsytp.length){
        clearInterval(this.jishi);
        var jztdh=document.getElementById("jztdh")
        jztdh.style.animationPlayState="paused"
        }
      }
      if (this.loajs == 100) {
        clearInterval(this.jishi);
        this.ymsx = 2;
      }
    },
    mcs: function () {
      if (this.mcs == 100) {
        clearInterval(this.mcjs);
        var lele= Math.floor(Math.random()*10)
        console.log(lele)
        if(lele<4){
          this.txx=this.txq[0]
        }else if(lele>6){
          this.txx=this.txq[1]
        }else{
          this.txx=this.txq[2]

        }
        this.ymsx = 5;
              setTimeout(() => {
            this.qiequ();
      }, 1000);
        
      }
    },
  },
  methods: {
    waaa(){
// var script = document.createElement("script")
// script.type = 'text/javascript'
// script.src = 'https://api.xiaoxxx.com/sensitive?callback=backfn&word=' + `'${this.nam}'`
// document.head.appendChild(script)
// document.head.removeChild(script)
// window.backfn = (e) => {
//   console.log(e)
//   if(e.data.words.length!=0){
//       console.log("有违规")
//                       this.tsks=1
//         this.tsnr="您的名字中包含敏感词汇哦，换个名字试试"
//           setTimeout(()=>{this.tsks=0,this.tsnr=""},1500)
//   }else{
            this.pbl();
        this.ymsx = 4;
//   }
// }
    },
    // szyds(){
    //   clearInterval(this.timer);
      
    // },
       //跳转其他网站
    zzzb(){
      // window.open="http://download.uc.cn/download/quark?ch=kk@other_pr1"
      window.location.href="https://broccoli.uc.cn/apps/JH5_3uFF2/routes/2021keyword?uc_param_str=dsdnfrpfbivesscpgimibtbmnijblauputogpintnwkt&uc_biz_str=S%3Acustom%7CC%3Afull_screen&entry=pr1"
      window._czc.push(["_trackEvent", "跳转", "夸克", "下载", "页面", "1"]);
    },
    // 暂停播放
    ztbf(){
      this.yy=2
      console.log(2)
      var yyfh=document.getElementById("yyfh")
        yyfh.style.animationPlayState="paused"
    },
    // 开始播放
    ztsj(){
      this.yy=1
      // console.log(1)
      var yyfh=document.getElementById("yyfh")
        yyfh.style.animationPlayState="running"
    },
    //音乐
    yinyue(){

      var yin=document.getElementById("yinyue")
      
      if(this.yy==1){
        yin.pause()
      }else{
        yin.play()
      }
      
    },
    //预加载
    tjz(){
      for(var i=0;i<this.yjzsytp.length;i++){
          const imga= new Image()
          imga.src=this.yjzsytp[i].img
          imga.onload=()=>{
            this.tp++
          }
      }

    },
    // 屏幕切图
    qiequ() {
      var $this = this;
      // var
      html2canvas(document.getElementById("wang"), {
        width: document.querySelector("#wang").scrollWidth,
        height: document.querySelector("#wang").scrollHeight,
        windowWidth: document.querySelector("#wang").scrollWidth,
        windowHeight: document.querySelector("#wang").scrollHeight,
        x: 0,
        y: window.pageYOffset,
        //   allowTaint: false,
        // logging: false,
        // useCORS: true
      }).then(function (canvas) {
        $this.scdtp = canvas.toDataURL();
        console.log($this.scdtp);
        document.body.appendChild(canvas);
      });
    },
    // 确认生成
    sctp() {
      if(this.bcxzx.length==""){
                this.tsk=1
        this.tsnr="您还没选呢!"
          setTimeout(()=>{this.tsk=0,this.tsnr=""},1500)
      }
      if(this.bcxzx.length!=""){
            this.mcloa = 1;
            clearInterval(this.timer);
            this.mcjs = setInterval(() => {
              this.mcs++;
            }, 50);

      }
    },
    //图标页返回输入名字页面
    fh3() {
      clearInterval(this.timer);
      this.ymsx = 3;
      this.bcxzx=[]
    },
    // 选中效果
    tjjgh(i, val) {
      var xzk = document.getElementById(`xz${i}`);
      if (xzk.style.display == "none") {
        if(i>49){
          var xzx = document.getElementById(`xz${i - 50}`);
        }else{
          var xzx = document.getElementById(`xz${i + 50}`);
        }
        
        xzk.style.display = "block";
        xzx.style.display = "block";
        this.bcxzx.push(val);
        console.log(this.bcxzx);
      } else if (xzk.style.display == "block") {
          if(i>49){
          var xzx = document.getElementById(`xz${i - 50}`);
        }else{
          var xzx = document.getElementById(`xz${i + 50}`);
        }
        xzk.style.display = "none";
        xzx.style.display = "none";
        for (var i = 0; i < this.bcxzx.length; i++) {
          if (this.bcxzx[i] == val) {
            this.bcxzx.splice(i, 1);
            console.log(this.bcxzx);
          }
        }
      }
    },
    //把拿到的数据分开放到两个数组中
    tbfs() {
      for (var i = 0; i < this.itb3.length; i++) {
        var imgs = document.getElementById(`ds${i}`);
        if (i % 2 == 0) {
          imgs.style.transform = `translate(210px)`;
          imgs.style.animationName = "tbdh1";
        } else if (i % 2 == 1) {
          imgs.style.transform = `translate(28px)`;
          imgs.style.animationName = "tbdh2";
        }
      }
    },
    // 让图标分散开来
    // tbfs(){
    //   for(var i=0;i<50;i++){
    //     var imgs=document.getElementById(`ds${i}`)
    //     console.log(imgs)

    //     // if(i<25){
    //     //   imgs.style.transform=`translate(100px)`
    //     // }
    //   }
    // },
    //把拿到的数据赋值成两份
    pbl() {
      this.itb3 = this.itb1.concat(this.itb1);
      console.log(this.itb3);
      setTimeout(() => {
        this.jsul();
        this.tbfs();
      }, 10);
    },
    //111往期回顾模块获取图片的长度
    jsul() {
      console.log(this.lis);
      var oli = document.getElementsByClassName("oli");
      console.log(oli);
      for (var i = 0; i < oli.length; i++) {
        this.lis += oli[i].offsetHeight;
        console.log(this.lis);
        if (i == oli.length - 1) {
          this.tpgd();
          console.log(this.lis);
        }
      }
    },
    //111往期回顾模块把图片的长度赋值给父元素图片动起来
    tpgd() {
      console.log("循环完了", this.lis);
      var oul = document.getElementById("ul1");
      oul.style.height = this.lis + "px";
      this.timer = setInterval(() => {
        this.move();
      }, 50);
    },
    //111往期回顾模块让图片动起来
    move() {
      var oul = document.getElementById("ul1");
      if (oul.offsetTop < -(oul.offsetHeight / 2)) {
        //向左滚动，当靠左的图4移出边框时
        oul.style.top = 0;
      }
      // if (oul.offsetLeft > 0) { //向右滚动，当靠右的图1移出边框时
      //     oul.style.left = -(oul.offsetWidth / 2) + 'px';
      // }
      oul.style.top = oul.offsetTop + -1 + "px"; //向左滚动的时候为-2，向右滚动为正2
    },
    // -----------------------------------
    //确认名字
    qrmz() {
      if(this.nam==""){
        this.tsk=1
        this.tsnr="名字不能为空哦!"
          setTimeout(()=>{this.tsk=0,this.tsnr=""},1500)
      }
      if (this.nam != "") {
        this.waaa()
        // this.pbl();
        // this.ymsx = 4;
      }
    },
    // 首页手指移动事件
    szyd(e) {
this.hdjs = e.touches[0].pageX;
      console.log("2", this.hdjs);
      this.dddwz = this.hdjs - this.anxd;
      var hdys = document.getElementById("hdys");
      if (this.dddwz < 0) {
        this.ydyc = 0;
        hdys.style.transform = `translate(${this.dddwz}px)`;
      }

      console.log(12, this.dddwz);
      if (this.dddwz < -106) {
        this.ymsx = 3;
      }
    },
    // 首页手指按下事件
    szax(e) {
      this.anxd = e.touches[0].pageX;
    },
    // 首页手指松开事件
    szlk() {
      var hdys = document.getElementById("hdys");
      if (this.dddwz < 100) {
        hdys.style.transform = `translate(0px)`;
      } else if (this.dddwz >= 100) {
        this.ymsx = 3;
      }
      this.ydyc = 1;
    },
    // 加载条
    dsqs() {
      this.jishi = setInterval(() => {
        this.loajs++;
      }, 50);
    },
  },
};
</script>
<style>
.dzcgs{
  position: fixed;
  width: 5.5rem;
  height: 1.6rem;
  top: 2rem;
  left: 50%;
  transform: translate(-50%);
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  font-size: 0.4rem;
  line-height: 0.6rem;
  z-index: 9999;
  border-radius: 0.3rem;
}
.dzcgs span{
  letter-spacing:0.04rem;
  width: 5.5rem;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
}
.dzcg{
  position: fixed;
  width: 4.6rem;
  height: 1rem;
  top: 2rem;
  left: 50%;
  transform: translate(-50%);
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  font-size: 0.5rem;
  line-height: 0.5rem;
  z-index: 9999;
  border-radius: 0.3rem;
}
.dzcg span{
  letter-spacing:0.04rem;
  width: 5rem;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
}
.bg5 .scdtp{
  width: 100%;
  opacity: 0;
  position: absolute;
  z-index: 99;
  height: 5rem;
  left: 0rem;
  top: 0rem;
}
.bg5 .scdtps{
  width: 3.5rem;
  opacity: 0;
  position: absolute;
  z-index: 99;
  height: 3.1rem;
  right: 0rem;
  bottom: 0rem;
}
.bg5 .scdtpss{
  width: 5rem;
  opacity: 0;
  position: absolute;
  z-index: 99;
  height: 2rem;
  left: 0rem;
  bottom: 1.45rem;
}


.bg6 .wldd{
  height: 3rem;
  width: 100%;
  position: relative;
  /* background-color: violet; */
}
.bg6 .wan1{
position: absolute;
top: 1.5rem;
left: 0.8rem;
height: 0.84rem;
}
.bg6 .wan2{
position: absolute;
top: 1.2rem;
left: 5.5rem;
height: 1.4rem;
}
.bg6 .gtk{
   position: relative;
  width: 6.7rem;
  left: 50%;
  height: 4rem;
  /* top: 50%; */
  transform: translate(-50%);
  /* margin-top: 0.1rem; */
  /* background-color: violet; */
}
.bg6 .dibu3 {
  height: 1.4rem;
  position: absolute;
  bottom: 0.2rem;
  left: 4.7rem;
}
.bg6 .dibu2 {
  height: 0.65rem;
  position: absolute;
  bottom: 1rem;
  left: 0.5rem;
  z-index: 99889;
}
.bg6 .dibu {
  height: 0.6rem;
  position: absolute;
  bottom: 0.3rem;
  left: 0.4rem;
}
.bg6 .buzz {
  width: 6.7rem;
  height: 3rem;
  position: absolute;
  bottom: 0rem;
  left: 50%;
  /* background-color: violet; */
  transform: translate(-50%);
}
.bg6 .xzdk .tpk img {
  text-align: center;
  height: 2rem;
  max-width: 2rem;
  position: absolute;
  left: 0rem;
  /* display: block; */
  left: 50%;
  transform: translate(-50%);
}
.bg6 .xzdk .tpk {
  text-align: center;
  width: 2rem;
  text-align: left;
  position: relative;
  display: inline-block;
  height: 2.2rem;
  
  margin-left: 0.17rem;
  /* margin-top: 0.17rem;  */
  /* background-color: violet; */
}
.wang {
  position: fixed;
  width: 100%;
  top: 0rem;
  z-index: 10000;
}
.bg6 .xzdk {
  text-align: left;
  /* overflow-y: auto; */
  /* text-align: left; */
  /* height: 5rem; */
  /* margin-top: 0.5rem; */
  width: 6.7rem;
  /* background-color: rgb(209, 209, 209); */
  position: relative;
  left: 50%;
  transform: translate(-50%);
  /* top: 5.5rem; */
}
.bg6 .ftiao {
  /* width: 100%; */
  height: 0.25rem;
  position: absolute;
  top: 0.15rem;
  left: 50%;
  transform: translate(-53%);
  /* left: -0.1rem; */
}
.bg6 .ftbg {
  width: 100%;
  height: 0.54rem;
  background-color: #ffbd23;
  position: relative;
  /* top: 4rem; */
  /* left: -2rem; */
}
.bg6 .namm {
  position: absolute;
  top: 2.75rem;
  left: 0rem;
  font-size: 0.35rem;
  font-weight: bold;
  width: 2rem;
  text-align: center;
  /* background-color: white; */
}
.bg6 .bttp {
  height: 1.59rem;
  top: 1.2rem;
  left: 2.1rem;
  position: absolute;
}
.bg6 .toux {
  top: 0rem;

  width: 100%;
}
.bg6 .txk {
  overflow: hidden;
  width: 1.46rem;
  height: 1.46rem;
  position: absolute;
  top: 1.2rem;
  border: 1.5px solid #534dff;
  background-color: white;
  left: 0.2rem;
  border-radius: 50%;
}
.bg6 .logo {
  height: 0.46rem;
  left: 0rem;
  position: absolute;
  top: 0.2rem;
}
.bg6 .bgt {
  /* top: 0rem; */
  width: 100%;
  position: absolute;
  left: 0rem;
  top: 0rem;
}
.bg6 .bgd {
  /* top: 0rem; */
  width: 100%;
  position: absolute;
  left: 0rem;
  bottom: 0rem;
}

.bg6 .bgz {
  position: absolute;
  width: 6.7rem;
  left: 50%;
  height: 13rem;
  top: 50%;
  transform: translate(-50%, -50%);
  /* background-color: aqua; */
}
.gdtgb{
width: 100%;
height: 100vh;
position: fixed;
overflow: hidden;
}
*:-webkit-scrollbar {
  width: 0 !important;
}
*{
  -ms-overflow-style: none;
}
*{
  overflow: -moz-scrollbars-none;
}
.bg6 .bgz::-webkit-scrollbar {
  width: 0 !important;
}
.bg6 .bgz {
  -ms-overflow-style: none;
}
.bg6 .bgz {
  overflow: -moz-scrollbars-none;
}
.bg6 {
  z-index: -1;
  background-color: #ffd03e;
  position: relative;
  width: 100%;
  /* height: 100vh; */
  /* min-height: 13rem; */
  /* background-size: cover; */
  /* background-position: center top; */
  /* overflow: hidden; */
}
/* ================================================================================================== */
.bg5 .dibu3 {
  height: 1.4rem;
  position: absolute;
  bottom: 0.2rem;
  left: 4.7rem;
}
.bg5 .dibu2 {
  height: 0.65rem;
  position: absolute;
  bottom: 1rem;
  left: 0.5rem;
  z-index: 99999;
}
.bg5 .dibu {
  height: 0.6rem;
  position: absolute;
  bottom: 0.3rem;
  left: 0.4rem;
  z-index: 99999;

}
.bg5 .buzz {
  width: 6.7rem;
  height: 2rem;
  position: absolute;
  bottom: 0.45rem;
  left: 50%;
  /* background-color: violet; */
  transform: translate(-50%);
}
.bg5 .xzdk .tpk img {
  text-align: center;
  height: 2rem;
  max-width: 2rem;
  position: absolute;
  left: 0rem;
  bottom: 0rem;
  /* display: block; */
  left: 50%;
  transform: translate(-50%);
}
.bg5 .xzdk .tpk {
  text-align: center;
  width: 2rem;
  text-align: left;
  position: relative;
  display: inline-block;
  height: 2.2rem;
  margin-left: 0.17rem;
  /* margin-top: 0.17rem; */
  /* background-color: violet; */
}
.wang {
  position: fixed;
  width: 100%;
  top: 0rem;
  z-index: 10000;
}
.bg5 .xzdk {
  overflow-y: auto;
  text-align: left;
  height: 5rem;
  width: 100%;
  /* background-color: rgb(209, 209, 209); */
  position: absolute;
  top: 5.5rem;
  /* z-index: 9999999; */
}
.bg5 .ftiao {
  /* width: 100%; */
  height: 0.25rem;
  position: absolute;
  top: 4.15rem;
  left: -0.1rem;
}
.bg5 .ftbg {
  width: 200%;
  height: 0.54rem;
  background-color: #ffbd23;
  position: absolute;
  top: 4rem;
  left: -2rem;
}
.bg5 .namm {
  position: absolute;
  top: 2.75rem;
  left: 0rem;
  font-size: 0.35rem;
  font-weight: bold;
  width: 2rem;
  text-align: center;
  /* background-color: white; */
}
.bg5 .bttp {
  height: 1.59rem;
  top: 1.2rem;
  left: 2.1rem;
  position: absolute;
}
.bg5 .toux {
  top: 0rem;

  width: 100%;
}
.bg5 .txk {
  overflow: hidden;
  width: 1.46rem;
  height: 1.46rem;
  position: absolute;
  top: 1.2rem;
  border: 1.5px solid #534dff;
  background-color: white;
  left: 0.2rem;
  border-radius: 50%;
}
.bg5 .logo {
  height: 0.46rem;
  left: 0rem;
  position: absolute;
  top: 0.2rem;
}
.bg5 .bgt {
  /* top: 0rem; */
  width: 100%;
  position: absolute;
  left: 0rem;
  top: 0rem;
}
.bg5 .bgd {
  /* top: 0rem; */
  width: 100%;
  height: 3.7rem;
  position: absolute;
  left: 0rem;
  bottom: 0rem;
}

.bg5 .bgz {
  position: absolute;
  width: 6.7rem;
  left: 50%;
  height: 13rem;
  top: 50%;
  transform: translate(-50%, -50%);
  /* background-color: aqua; */
}
.bg5 {
  background-color: #ffd03e;
  position: fixed;
  /* display: none; */
  width: 100%;
  height: 100vh;
  min-height: 13rem;
  background-size: cover;
  background-position: center top;
  overflow: hidden;
  z-index: 100;
}

/* 年度关键词页面 -------------------------------------------------------------------------------------------------------------------------------------*/
@keyframes tbdh1 {
  0% {
    transform: translate(210px, 0);
  }
  25% {
    transform: translate(230px, 0px);
  }
  50% {
    transform: translate(200px, 10px);
  }
  75% {
    transform: translate(220px, 10px);
  }
  100% {
    transform: translate(210px, 0);
  }
}
@keyframes tbdh2 {
  0% {
    transform: translate(28px, 0);
  }
  25% {
    transform: translate(50px, 20px);
  }
  50% {
    transform: translate(40px, 10px);
  }
  75% {
    transform: translate(30px, 10px);
  }
  100% {
    transform: translate(28px, 0);
  }
}
@keyframes xzxz {

  0% {
    transform: translate(0px);
    opacity: 0;
  }
  1% {
    transform: translate(-500px);
    opacity: 0;

  }
  2%{
      opacity: 1;
  }
  20% {
    transform:translate(0px); 
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(180deg);
  }
}
.bg4 .jzt {
  height: 0.53rem;
  top: 50%;
  transform: translateY(-50%);
  position: absolute;
  left: -3.45rem;
  width: 3.45rem;
  animation: wang 5s linear forwards;
  z-index: 999;
}
.bg4 .bfb {
  top: 0rem;
  font-size: 0.5rem;
  font-weight: bold;
  position: absolute;
  left: 50%;
  transform: translate(-50%);
  font-family: "Clarendon Blk BT", "YouSheBiaoTiHei";
  color: #fffe04;
  z-index: 4;
}
.bg4 .nck {
  height: 0.55rem;
  width: 3.4rem;
  position: absolute;
  /* background-color: chartreuse; */
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 20px;
  overflow: hidden;
}
.bg4 .srk {
  width: 3.64rem;
  height: 0.66rem;
  background-color: rgb(250, 250, 250);
  top: 0.65rem;
  left: 50%;
  transform: translate(-50%);
  position: absolute;
  border-radius: 30px;
  border: 1.5px solid #534dff;
  z-index: 4;
}
.bg4 .nzgjc {
  width: 5rem;
  top: 1.5rem;
  font-size: 0.3rem;
  /* font-weight: bold; */
  position: absolute;
  left: 50%;
  transform: translate(-50%);
  font-family: "Clarendon Blk BT", "YouSheBiaoTiHei";
  color: #ffffff;
  z-index: 4;
}
.bg4 .scjz {
  width: 6.5rem;
  height: 2.1rem;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  /* z-index: 9; */
  z-index: 99999999999999999;
  /* display: none; */
}

.bg4 .mengcen {
  width: 100%;
  height: 100vh;
  position: fixed;
  z-index: 99999999999999999;
  background-color: rgba(0, 0, 0, 0.7);
}
.bg4 .sz {
  color: #534dff;
}
.bg4 .wzz {
  position: absolute;
  /* width: 2.65rem; */
  height: 0.74rem;
  bottom: 0.1rem;
  z-index: 2;
  right: 0.5rem;
  font-size: 0.4rem;
  font-weight: bold;
  font-family: "Clarendon Blk BT", "YouSheBiao TiHei";
  /* color: #534dff; */
}
.bg4 .qrsc {
  position: fixed;
  /* width: 2.65rem; */
  height: 1rem;
  bottom: 0.7rem;
  z-index: 2;
  right: 0.5rem;
}
.bg4 .fhsy {
  position: absolute;
  /* width: 2.65rem; */
  height: 0.74rem;
  bottom: 0.14rem;
  z-index: 2;
  left: 0.5rem;
}
.bg4 .dingbu {
  width: 100%;
  height: 1.3rem;
  top: 0rem;
  left: 0rem;
  position: fixed;
  /* background-color: #615f59; */
  background-color: #ffd03e;

  z-index: 9999;
}
.bg4 .fgh {
  position: absolute;
  left: -0.5rem;
  width: 3.4rem;
  /* opacity: 0; */
  /* transform: translate(-500px); */
  /* height: 3rem; */
  bottom: -0.2rem;
  animation: xzxz 5s linear;
  /* display: none; */
}
.bg4 .xzdh {
  position: absolute;
  left: 2rem;
  top: 1.95rem;
  width: 0.41rem;
}
.bg4 .ds1 .tbimg {
  height: 2.5rem;
  /* margin-bottom: 0.2rem; */
  position: relative;
  display: block;
}
.bg4 .ds1 .oli {
  position: relative;
  animation-duration: 10s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
}
.bg4 .bgz::-webkit-scrollbar {
  width: 0 !important;
}
.bg4 .bgz {
  -ms-overflow-style: none;
}
.bg4 .bgz {
  overflow: -moz-scrollbars-none;
}
.bg4 .ds1 {
  /* overflow-Y: auto; */
  /* overflow-X: hidden; */
  position: absolute;
  left: 50%;
  transform: translate(-50%);
  top: 0rem;
  /* height: 20rem; */
  width: 7rem;
  /* background-color: chartreuse; */
}
.bg4 .bgz {
  /* background-color: coral; */
  overflow-y: auto;
  overflow-x: hidden;
  height: 100vh;
  width: 100%;
  position: absolute;
  left: 50%;
  /* height: 0.83rem; */
  transform: translate(-50%);
  /* position: absolute; */
}
.bg4 {
  background-color: #ffd03e;
  position: fixed;
  width: 100%;
  height: 100vh;
  min-height: 13rem;
  background-size: cover;
  background-position: center top;
  overflow: hidden;
}
/* ---------------------------------------------------------------------------------------------------------------------------------------------------------- */

/* 输入姓名页面 -------------------------------------------------------------------------------------------------------------------------------------*/
.bg3 .qrmz {
  position: absolute;
  top: 6.37rem;
  left: 50%;
  height: 0.83rem;
  transform: translate(-50%);
}
.bg3 .srk {
  width: 3.28rem;
  height: 0.75rem;
  top: 5.08rem;
  position: absolute;
  left: 50%;
  transform: translate(-50%);
  border: none;
  border-radius: 30px;
  font-size: 0.3rem;
  font-weight: bold;
  letter-spacing: 0.02rem;
  padding-left: 0.3rem;
  padding-right: 0.3rem;
}
.bg3 .qsr {
  position: absolute;
  top: 4.42rem;
  left: 50%;
  height: 0.45rem;
  transform: translate(-50%);
}
.bg3 .xr {
  height: 3.98rem;
  top: 8.8rem;
  position: absolute;
  left: 50%;
  transform: translate(-50%);
}
.bg3 .zbt {
  height: 1.78rem;
  position: absolute;
  top: 1.4rem;
  left: 50%;
  transform: translate(-50%);
}
.bg3 .logo {
  height: 0.46rem;
  left: 0rem;
  position: absolute;
  top: 0.2rem;
}
.bg3 .bgz {
  position: absolute;
  width: 6.7rem;
  left: 50%;
  height: 13rem;
  top: 50%;
  transform: translate(-50%, -50%);
  /* background-color: aqua; */
}
.bg3 {
  background: url(../assets/loa/bg.png) no-repeat;
  position: fixed;
  width: 100%;
  height: 100vh;
  min-height: 13rem;
  background-size: cover;
  background-position: center top;
  overflow: hidden;
}
/* ---------------------------------------------------------------------------------------------------------------------------------------------------------- */

/* 首页样式 -------------------------------------------------------------------------------------------------------------------------------------*/
.bg2 .yhks {
  height: 0.4rem;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0.6rem;
}
.bg2 .ncsrk .yqq .hdks {
  /* width: 0.56rem; */
  height: 0.36rem;
  position: absolute;
  top: 0.25rem;
  left: 0.18rem;
}
.bg2 .ncsrk .yqq {
  width: 0.9rem;
  height: 0.9rem;
  position: absolute;
  top: 0;
  left: 0rem;
  background-color: #534dff;
  border-radius: 50%;
}
.bg2 .ncsrk {
  width: 2.5rem;
  height: 0.8rem;
  position: absolute;
  top: 0.05rem;
  transform: translate(0px);
  right: -1.55rem;
  /* transform: translateY(-50%); */
  background-color: rgb(255, 255, 255);
  border-radius: 30rem;
}
.bg2 .srk {
  overflow: hidden;
  width: 3.6rem;
  height: 1rem;
  background-color: rgb(250, 250, 250);
  top: 7rem;
  left: 50%;
  transform: translate(-50%);
  position: absolute;
  border-radius: 30px;
  border: 1.5px solid #534dff;
}
.bg2 .wzys {
  height: 2.05rem;
  position: absolute;
  top: 4rem;
  left: 50%;
  transform: translate(-50%);
}
.bg2 .xr {
  height: 3.98rem;
  top: 8.8rem;
  position: absolute;
  left: 50%;
  transform: translate(-50%);
}
.bg2 .zbt {
  height: 1.78rem;
  position: absolute;
  top: 1.4rem;
  left: 50%;
  transform: translate(-50%);
}
.bg2 .logo {
  height: 0.46rem;
  left: 0rem;
  position: absolute;
  top: 0.2rem;
}
.bg2 .bgz {
  position: absolute;
  width: 6.7rem;
  left: 50%;
  height: 13rem;
  top: 50%;
  transform: translate(-50%, -50%);
  /* background-color: aqua; */
}
.bg2 {
  background: url(../assets/loa/bg.png) no-repeat;
  position: fixed;
  width: 100%;
  height: 100vh;
  min-height: 13rem;
  background-size: cover;
  background-position: center top;
  overflow: hidden;
}
/* ---------------------------------------------------------------------------------------------------------------------------------------------------------- */

/* loa加载页面样式 -------------------------------------------------------------------------------------------------------------------------------------*/
@keyframes wang {
  0% {
    left: -3.45rem;
  }
  100% {
    left: 0rem;
  }
}
.bg1 .jzt {
  height: 0.53rem;
  top: 50%;
  transform: translateY(-50%);
  position: absolute;
  left: -3.45rem;
  width: 3.45rem;
  animation: wang 5s linear forwards;
  z-index: 999;
}
.bg1 .bfb {
  top: 8.95rem;
  font-size: 0.5rem;
  font-weight: bold;
  position: absolute;
  left: 50%;
  transform: translate(-50%);
  font-family: "Clarendon Blk BT", "YouSheBiaoTiHei";
  color: #534dff;
}
.bg1 .nck {
  height: 0.55rem;
  width: 3.4rem;
  position: absolute;
  /* background-color: chartreuse; */
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 20px;
  overflow: hidden;
}
.bg1 .srk {
  width: 3.64rem;
  height: 0.66rem;
  background-color: rgb(250, 250, 250);
  top: 9.6rem;
  left: 50%;
  transform: translate(-50%);
  position: absolute;
  border-radius: 30px;
  border: 1.5px solid #534dff;
}
.bg1 .xr {
  height: 3.98rem;
  top: 3.92rem;
  position: absolute;
  left: 50%;
  transform: translate(-50%);
}
.bg1 .zbt {
  height: 1.78rem;
  position: absolute;
  top: 1.4rem;
  left: 50%;
  transform: translate(-50%);
}
.bg1 .yyfh {
  height: 0.36rem;
  position: absolute;
  left: 0.1rem;
  top: 0.15rem;
  animation: yyfh 5s linear  infinite;
  animation-fill-mode: backwards;
  /* transform: translate(-50%); */
}
@keyframes yyfh {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.bg1 .yuyq {
  width: 0.62rem;
  height: 0.62rem;
  position: absolute;
  right: 0;
  top: 0.2rem;
  border-radius: 50%;
  background-color: #534dff;
}
.bg1 .logo {
  height: 0.46rem;
  left: 0rem;
  position: absolute;
  top: 0.2rem;
}
.bg1 .bgz {
  position: absolute;
  width: 6.7rem;
  left: 50%;
  height: 13rem;
  top: 50%;
  transform: translate(-50%, -50%);
  /* background-color: aqua; */
}
.bg1 {
  background: url(../assets/loa/bg.png) no-repeat;
  position: fixed;
  width: 100%;
  height: 100vh;
  min-height: 13rem;
  background-size: cover;
  background-position: center top;
  overflow: hidden;
}
/* ---------------------------------------------------------------------------------------------------------------------------------------------------------- */
</style>
